import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorStore, Guide } from '@sleipai/sleip-models';

export const GuideActions = createActionGroup({
  source: 'GuideActions',
  events: {
    loadGuides: emptyProps(),
    loadGuidesSuccess: props<{ guides: Guide[] }>(),
    loadGuidesFailure: props<{ error: ErrorStore | string | null | any }>(),
  },
});
